"use client";
import React from "react";
import styles from "./availability-indicator.module.scss";
import { ProductVariantAvailabilityEnum } from "@/graphql";
import { useTranslations } from "next-intl";

interface AvailabilityIndicatorProps {
  availability: ProductVariantAvailabilityEnum;
}

const AvailabilityIndicator: React.FC<AvailabilityIndicatorProps> = ({
  availability,
}) => {
  let text;
  let dotColorClass;
  const t = useTranslations("Components.availability-indicator");

  switch (availability) {
    case ProductVariantAvailabilityEnum.PRE_ORDER:
      text = t("pre-order");
      dotColorClass = styles.dotPreOrder;
      break;
    case ProductVariantAvailabilityEnum.COMING_SOON:
      text = t("soon");
      dotColorClass = styles.dotComingSoon;
      break;
    case ProductVariantAvailabilityEnum.IN_STOCK:
      text = t("stock");
      dotColorClass = styles.dotInStock;
      break;
    case ProductVariantAvailabilityEnum.LAST_ONE_REMAINING:
      text = t("last-one");
      dotColorClass = styles.dotLastOne;
      break;
    case ProductVariantAvailabilityEnum.OUT_OF_STOCK:
      text = t("not-available");
      dotColorClass = styles.dotOutOfStock;
      break;
  }

  return (
    <div className={styles.stock}>
      <div className={`${styles.dot} ${dotColorClass}`}></div>
      <p>{text}</p>
    </div>
  );
};

export default AvailabilityIndicator;
